export default "__VITE_PUBLIC_ASSET__b9764904__"